import React, {useId} from 'react';

import styles from './StarIcon.module.scss';

type Props = {
  offset: number;
  color: string;
};

export const StarIcon: React.FC<Props> = ({offset, color}) => {
  const id = useId();

  return (
    <svg
      className={styles.starIcon}
      viewBox="0 0 14 14"
      id={id}
      data-name="Livello 1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={`fill${id}`}>
          <stop offset={`${offset}`} stopColor={`${color}`}></stop>
          <stop offset={`${offset}`} stopColor="rgba(255,0,0,0)"></stop>
        </linearGradient>
      </defs>
      <path
        fill={`url(#fill${id})`}
        // eslint-disable-next-line max-len
        d="M9.22929 4.65664L12.1823 4.93996C13.2099 5.03854 13.525 6.04226 12.7316 6.70169L10.4196 8.62313L11.2779 11.7533C11.5598 12.7813 10.6853 13.4036 9.80946 12.7849L7.00033 10.8007L4.1912 12.7849C3.31889 13.4011 2.44087 12.7814 2.72276 11.7533L3.58102 8.62313L1.26911 6.70169C0.472333 6.03949 0.786222 5.03899 1.81816 4.93996L4.77067 4.65664L6.07147 1.65755C6.47882 0.71835 7.52208 0.718821 7.9291 1.65765L9.22929 4.65664Z"
        stroke={`${color}`}
        fillRule="evenodd"
        clipRule="evenodd"
        strokeMiterlimit="10"
        strokeWidth="1.7px"
      />
    </svg>
  );
};
